<template>
  <footer
    class="
        bg-white
        border-t-2 border-#00000029
        fixed
        inset-x-0
        bottom-0
        p-2"
  >
    <div class="d-flex justify-center">
      <v-btn
        color="primary"
        variant="text"
        class="text-caption -m-2"
      >
        <NuxtLink to="https://www.mein-elysium.app/rechtliches#c436" target="_blank">
          {{ $t('components.AppFooter.privacy') }}
        </NuxtLink>
      </v-btn>
      <span class="-mt-0.5">&#183;</span>
      <v-btn
        color="primary"
        variant="text"
        class="text-caption -m-2"
      >
        <NuxtLink to="https://www.mein-elysium.app/impressum" target="_blank">
          {{ $t('components.AppFooter.legal') }}
        </NuxtLink>
      </v-btn>
    </div>
  </footer>
</template>
